import { render } from "./Administrativo.vue?vue&type=template&id=5dc29563&scoped=true"
import script from "./Administrativo.vue?vue&type=script&lang=js"
export * from "./Administrativo.vue?vue&type=script&lang=js"

import "./Administrativo.vue?vue&type=style&index=0&id=5dc29563&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc29563"]])

export default __exports__